import { Component, input } from '@angular/core';
import { BulletComponent } from '../bullet/bullet.component';

@Component({
  selector: 'app-card-title',
  imports: [BulletComponent],
  templateUrl: './card-title.component.html',
  styleUrl: './card-title.component.css',
})
export class CardTitleComponent {
  public bullet = input<string>();
  public title = input<string>();
  public subtitle = input<string>();
}
